<template>
  <div class="find-blood-page">
    <top-bar title="Find Bloodbag">
      <img src="@/assets/icon/magnifying-glass.png" alt="magnifying glass icon">
    </top-bar>
    <container class="search-filter">
      <div class="col-12 row justify-content-md-center mt-5">
        <div class="col-md-10 col-xs-12 offset-1">
          <div class="mt-sm-5 mb-sm-5" style="width: 100%">
            <div class="form-row">
              <div class="col-md-8 col-xs-12">
                <div class="row">
                  <div class="form-group mb-2 col-md-5 col-xs-12">
                    <select class="form-control text-primary"
                      v-model="petTypeSelected"
                      id="petTypeSelected"
                      name="petTypeSelected">
                      <option value="">ทุกชนิดสัตว์</option>
                      <option value="Dog/สุนัข">สุนัข</option>
                      <option value="Cat/แมว">แมว</option>
                    </select>
                  </div>
                  <div class="form-group mb-2 col-md-5 col-xs-12">
                    <select class="form-control text-primary"
                      v-model="hospitalProvinceSelected"
                      id="hospitalProvinceSelected"
                      name="hospitalProvinceSelected">
                      <option value="">ทุกจังหวัด</option>
                      <option v-for="(text, idx) in provinceList" v-bind:key="idx">{{ text }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-primary mx-sm-5 col-xs-12 mb-2 col align-self-end"
                @click="submitFilter">
                Search</button>
            </div>
          </div>
        </div>
      </div>
    </container>

    <container class="hospital-card-container">
      <hospital-card class="h-card" v-for="hospital in selectedHospitalList" :key="hospital.name"
        :showBloodBag="true"
        :petTypeFilter="petTypeFilter"
        :hospital="hospital"
        v-on:emptyBloodBags="removeHospitalEmptyBloodBags"/>
    </container>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import Container from '@/components/Container.vue'
import HospitalCard from '@/components/HospitalCard.vue'

export default {
  name: 'FindBlood',
  data () {
    return {
      hospitalList: [],
      selectedHospitalList: [],
      provinceList: [],
      petTypeFilter: '',
      petTypeSelected: '',
      hospitalProvinceSelected: ''
    }
  },
  mounted () {
    this.$http.get('hospital/hospital/').then((response) => {
      this.hospitalList = response.data.result.filter(
        hospital => hospital.is_bloodbank_publish
      )
      this.filterHospital()
      this.initialFilter()
    })
  },
  methods: {
    initialFilter () {
      for (var hospital of this.hospitalList) {
        if (hospital.address2) {
          var province = hospital.address2.province
          if (this.provinceList.indexOf(province) === -1) {
            this.provinceList.push(province)
          }
        }
      }
    },
    submitFilter () {
      this.filterHospital()
      this.filterPetTypeBloodBags()
    },
    filterHospital () {
      var hospitalProvinceSelected = this.hospitalProvinceSelected
      this.selectedHospitalList = this.hospitalList.filter(function (hospital) {
        if (hospitalProvinceSelected) {
          if (hospital.address2) {
            if (hospital.address2.province === hospitalProvinceSelected) {
              return hospital
            }
          }
        } else {
          return hospital
        }
      })
    },
    filterPetTypeBloodBags () {
      this.petTypeFilter = this.petTypeSelected
    },
    removeHospitalEmptyBloodBags (hospitalEmptybloodBags) {
      this.selectedHospitalList = this.selectedHospitalList.filter(function (hospital) {
        return hospital !== hospitalEmptybloodBags
      })
    }
  },
  components: {
    TopBar,
    Container,
    HospitalCard
  }
}
</script>

<style scoped lang="scss">
.find-blood-page {
  background-color: $gray-100;
}

.hospital-card-container {
  padding-left: 0;
  padding-right: 0;
  .h-card {
    margin-top: 1rem;
  }
}
</style>
